module.exports = __webpack_public_path__ + "static/media/logo01.4a916947.png";